import gql from "graphql-tag";
const UPDATE_EMAIL_TAG = gql`
  mutation changeEmail($changeEmailInput: ChangeEmailInput!) {
    changeEmail(changeEmailInput: $changeEmailInput) {
        success,
        message,
        err
    }
  }
`;

export const VERIFY_CHANGE_EMAIL_TAG = gql`
  mutation verifyChangeEmail($verifyChangeEmailInput: VerifyChangeEmailInput!) {
    verifyChangeEmail(verifyChangeEmailInput: $verifyChangeEmailInput) {
        success,
        message,
        err
    }
  }
`;

export default UPDATE_EMAIL_TAG;
